export const models = {
  title: "Serviços de IA",
  subtitle: "Confira todos os serviços de IA e seus preços.",
};
